import React from "react";
import {Alert, Card, Spinner} from "react-bootstrap";
import HelpTooltip from "../HelpTooltip.jsx";

/**
 * Einheitlicher Rahmen für alle Diagramm-/Auswertungskacheln der
 * Verkaufsstatistik: Titel mit optionaler Hilfe, feste Mindesthöhe (kein
 * Springen des Layouts beim Nachladen), sowie einheitliche Lade-, Fehler-
 * und Leerzustände.
 */
export default function ChartCard({
    title,
    help,
    loading = false,
    error = null,
    empty = false,
    emptyLabel = "Keine Daten für den gewählten Zeitraum und Filter.",
    height = 320,
    actions = null,
    className = "",
    children,
}) {
    return (
        <Card className={`shadow-sm h-100 ${className}`}>
            <Card.Header className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                <span className="d-inline-flex align-items-center gap-1 fw-semibold">
                    {title}
                    {help && (
                        <HelpTooltip placement="right" size={0.8}>
                            {help}
                        </HelpTooltip>
                    )}
                </span>
                {actions}
            </Card.Header>
            <Card.Body>
                <div style={{minHeight: height, position: "relative"}}>
                    {error && <Alert variant="danger" className="mb-0">{error}</Alert>}
                    {!error && loading && (
                        <div className="d-flex align-items-center justify-content-center" style={{height}}>
                            <Spinner animation="border" role="status" size="sm">
                                <span className="visually-hidden">Wird geladen…</span>
                            </Spinner>
                        </div>
                    )}
                    {!error && !loading && empty && (
                        <div className="d-flex align-items-center justify-content-center text-muted small text-center px-3" style={{height}}>
                            {emptyLabel}
                        </div>
                    )}
                    {!error && !loading && !empty && children}
                </div>
            </Card.Body>
        </Card>
    );
}
